import React, { useContext } from 'react';
import { SearchContext } from '../../../../App';

import classes from './ActivityResults.module.css';

const ActivityResults = () => {
  const { filteredActivities, updateSearchField, setActiveInput } = useContext(SearchContext);
  
  const handleSelect = (activity) => {    
    updateSearchField('activity', activity.name);
    setActiveInput(null);
  };

  const displayedActivities = filteredActivities.slice(0, 5);

  return (
    <div className={classes.resultsContainer}>
      <h1 className='semiboldXxs'>AKTIVITÄT O. STUDIO</h1>
      <div className={classes.results}>
        {displayedActivities.length > 0 ? (
          displayedActivities.map((activity) => (
            <div key={activity?.id} className={classes.resultItem} onClick={() => handleSelect(activity)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                <path d="M28.0833 14C28.0833 21.732 21.7967 28 14.0417 28C6.28667 28 0 21.732 0 14C0 6.26801 6.28667 0 14.0417 0C21.7967 0 28.0833 6.26801 28.0833 14Z" fill="#F0F1F4"/>
                <path d="M16.8205 16.0437C17.4705 15.2337 17.8305 14.2237 17.8305 13.1837C17.8305 10.6737 15.8005 8.6237 13.2905 8.6237C10.7805 8.6237 8.76054 10.6737 8.76054 13.1837C8.76054 15.6937 10.7905 17.7337 13.2905 17.7337C14.3305 17.7337 15.3505 17.3737 16.1505 16.7137L19.5805 20.0437L19.6905 20.1437L20.3405 19.4637L16.8205 16.0437ZM13.4405 16.7937H13.2905C11.3105 16.7937 9.70054 15.1737 9.70054 13.1737C9.70054 11.1737 11.3105 9.5737 13.2905 9.5737C15.2705 9.5737 16.8905 11.1937 16.8905 13.1837C16.8905 15.1737 15.3505 16.7137 13.4405 16.7937Z" fill="#77808A"/>
              </svg>
              <span className="mediumLarge">{activity?.name}</span>
            </div>
          ))
        ) : (
          <div className={classes.noResults}>Keine Aktivitäten gefunden.</div>
        )}
      </div>
    </div>
  );
};

export default ActivityResults;